import { render, staticRenderFns } from "./agreementtemplatelistform.vue?vue&type=template&id=52adc4cb&scoped=true&"
import script from "./agreementtemplatelistform.vue?vue&type=script&lang=js&"
export * from "./agreementtemplatelistform.vue?vue&type=script&lang=js&"
import style0 from "./agreementtemplatelistform.vue?vue&type=style&index=0&id=52adc4cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52adc4cb",
  null
  
)

export default component.exports